import React from 'react'
import {
  makeStyles,
} from '@material-ui/core'
import PickerToolbar from '@material-ui/pickers/_shared/PickerToolbar'
import ToolbarButton from '@material-ui/pickers/_shared/ToolbarButton'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    backgroundColor: '#f9b233',
  },
}))

const CustomToolbar = function (props) {
  const {
    date, isLandscape, openView, setOpenView, title,
  } = props

  const handleChangeViewClick = (view) => () => {
    setOpenView(view)
  }

  const classes = useStyles()

  return (
    <PickerToolbar
      className={classes.toolbar}
      title={title}
      isLandscape={isLandscape}
    >
      <ToolbarButton
        onClick={handleChangeViewClick('year')}
        variant="h6"
        label={date.format('jYYYY')}
        selected={openView === 'year'}
      />
      <ToolbarButton
        onClick={handleChangeViewClick('date')}
        variant="h4"
        selected={openView === 'date'}
        label={date.format('LL')}
      />
    </PickerToolbar>
  )
}

export default CustomToolbar
